<script lang="ts" generics="ROW">
    import type {Readable} from 'svelte/store';
    import type {Table, HeaderGroup} from '@tanstack/svelte-table';
    import {Render} from 'svelte-render';
    import {getRenderConfig} from 'shared/ui-widgets/grid/utils';
    import {getGridContext} from 'shared/ui-widgets/grid/grid.context';
    import KpGenericGridRow from 'shared/ui-widgets/grid/KpGenericGridRow.svelte';
    import ColumnResizer from '../../../features/record-grid/components/misc/ColumnResizer.svelte';
    import ColumnPinner from '../../../features/record-grid/components/misc/ColumnPinner.svelte';
    import KpGenericGridHeaderCell from 'shared/ui-widgets/grid/grid-cell/KpGenericGridHeaderCell.svelte';

    export let table$: Readable<Table<ROW>>;

    const {settings: {columnPinningEnabled, columnResizingEnabled, showOnlyTopAndBottomHeaders}} = getGridContext();

    function filterHeaderGroups(headerGroups: HeaderGroup<any>[]): HeaderGroup<any>[] {
        if (!showOnlyTopAndBottomHeaders || headerGroups.length < 2) {
            return headerGroups;
        }

        return [headerGroups.at(0), headerGroups.at(-1)];
    }

    $: filteredHeaderGroups = filterHeaderGroups($table$.getHeaderGroups());
</script>

<div class="kp-generic-grid-header">
    {#each filteredHeaderGroups as headerGroup, headerGroupIndex}
        <KpGenericGridRow>
            {#each headerGroup.headers as header, headerIndex}
                <KpGenericGridHeaderCell {header} isLastHeaderRow="{headerGroupIndex === filteredHeaderGroups.length - 1}">
                    {#if !header.isPlaceholder}
                        <Render of={getRenderConfig(header.column.columnDef.header, header.getContext())}/>
                    {/if}

                    {#if columnPinningEnabled && headerGroupIndex === 0}
                        <ColumnPinner column="{header.column}"/>
                    {/if}

                    {#if columnResizingEnabled && headerGroupIndex === 0}
                        <ColumnResizer {header} table="{$table$}" isLastColumn="{headerIndex === headerGroup.headers.length - 1}"/>
                    {/if}
                </KpGenericGridHeaderCell>
            {/each}
        </KpGenericGridRow>
    {/each}
</div>